import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20solemn%20and%20dignified%20architectural%20scene%20with%20classical%20marble%20columns%20and%20warm%20bronze%20accents%2C%20soft%20natural%20light%20streaming%20through%20tall%20windows%2C%20creating%20a%20sense%20of%20justice%20and%20truth%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20composition&width=1800&height=900&seq=hero-bg-home-01&orientation=landscape"
        alt="法律与正义 — 案件深度分析"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-primary-300 text-xs md:text-sm font-medium tracking-widest uppercase mb-3 md:mb-4">
            案件深度分析 · 专业解读
          </p>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4 md:mb-6">
            李宗瑞事件完整回顾与深度分析
          </h1>
          <p className="text-base md:text-lg text-foreground-200 leading-relaxed mb-6 md:mb-8 max-w-2xl mx-auto">
            涵盖事件经过、法律判决、社会影响及深度反思，汇整权威资讯，帮助读者全面了解案件始末
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/case-timeline"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 dark:text-foreground-950 px-6 py-3 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              查看事件经过
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/legal-analysis"
              className="inline-flex items-center gap-2 bg-background-50/15 text-foreground-50 border border-foreground-50/30 px-6 py-3 rounded-md text-sm font-medium hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              法律分析
              <i className="ri-scales-3-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}